import { ECountryCode } from 'src/modules/forms/fields/AreaCodeTextField/components/AreaCodeSelect';
import type { TSelectItem } from 'src/components/Search/components/types';
import { CONTACT_DEFAULT_AVATAR } from '../constants/images';
import { IStoreTag } from 'src/constants/store/tags';

export type TContactFormValues = {
    image: {
        style: string;
        seed: string;
    };
    name: string;
    email: string;
    phone: string;
    secondaryPhone: string;
    countryCode: ECountryCode;
    secondaryCountryCode: ECountryCode;
    employment: string;
    notes: string;
    store: string;
    users: TSelectItem[];
    tags: IStoreTag[];
};

export interface IContactFormProps {
    mode: 'create' | 'edit';
    initialValues?: Partial<TContactFormValues>;
    onSubmit: (values: TContactFormValues) => void | Promise<void>;
    isPhoneRequired?: boolean;
    loading: boolean;
    createdBy?: string;
    createdAt?: string;
}

export const defaultContactFormValues: TContactFormValues = {
    name: '',
    email: '',
    phone: '',
    secondaryPhone: '',
    countryCode: ECountryCode.Mexico,
    secondaryCountryCode: ECountryCode.Mexico,
    employment: '',
    notes: '',
    store: '',
    users: [],
    image: CONTACT_DEFAULT_AVATAR,
    tags: [],
};
